import { useSelector } from "react-redux";
import { Outlet, ScrollRestoration } from "react-router-dom";
import PublicFooterV2 from "../../components/ui/PublicFooterV2";
import { Fragment } from "react";
import ClosingPage from "../../components/common/Closing";

const HybridLayout = () => {
  const { isAuthenticated, isLoading } = useSelector((state) => state.auth);

  // While auth is resolving, we usually don't want to flash the footer
  if (isLoading) return null;

  return (
    <>
      <ScrollRestoration />

      {/* If guest: wrap in <main className="public"> for marketing styles.
          If logged in: just render the content so it fits your app dashboard.
      */}
      {!isAuthenticated ? (
        <Fragment>
          <main className="hybrid">
            <Outlet />
          </main>
          <PublicFooterV2 />
          <script src="main.js"></script>
        </Fragment>
      ) : (
        <main className="hybrid">
          <Outlet />
        </main>
      )}
    </>
  );
};

export default HybridLayout;
